var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart-01",
    clipPath: "url(#clip0_1913_15440)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.6665 1.66666H2.75497C2.95999 1.66666 3.0625 1.66666 3.14499 1.70436C3.21769 1.73758 3.27929 1.79101 3.32246 1.85828C3.37145 1.93461 3.38595 2.03609 3.41494 2.23904L3.80936 4.99999M3.80936 4.99999L4.68594 11.4428C4.79718 12.2604 4.85279 12.6692 5.04825 12.9769C5.22049 13.2481 5.46741 13.4637 5.7593 13.5978C6.09056 13.75 6.50312 13.75 7.32826 13.75H14.4598C15.2453 13.75 15.638 13.75 15.959 13.6087C16.242 13.4841 16.4847 13.2832 16.6601 13.0285C16.8589 12.7397 16.9324 12.3539 17.0794 11.5823L18.1824 5.7914C18.2342 5.51983 18.26 5.38404 18.2225 5.27791C18.1897 5.1848 18.1248 5.10639 18.0395 5.05667C17.9422 4.99999 17.804 4.99999 17.5275 4.99999H3.80936ZM8.33317 17.5C8.33317 17.9602 7.96007 18.3333 7.49984 18.3333C7.0396 18.3333 6.6665 17.9602 6.6665 17.5C6.6665 17.0398 7.0396 16.6667 7.49984 16.6667C7.96007 16.6667 8.33317 17.0398 8.33317 17.5ZM14.9998 17.5C14.9998 17.9602 14.6267 18.3333 14.1665 18.3333C13.7063 18.3333 13.3332 17.9602 13.3332 17.5C13.3332 17.0398 13.7063 16.6667 14.1665 16.6667C14.6267 16.6667 14.9998 17.0398 14.9998 17.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1913_15440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartWhite);
export default __webpack_public_path__ + "static/media/shopping-cart-white.0162e57556cb67a76120dfa6a0c735d4.svg";
export { ForwardRef as ReactComponent };